import React from 'react';
import { Modal } from 'antd';
import {
  useModalVisible,
  useSetModalVisible,
} from '../../model/modalState';

const BaseModal = ({ onCancel, width = 450,  ...props }) => {
  const visible = useModalVisible();
  const setVisible = useSetModalVisible();

  const handleCancel = () => {
    setVisible(false);

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  return (
    <Modal
      {...props}
      visible={visible}
      onCancel={handleCancel}
      width={width}
      destroyOnClose
    />
  );
};

export default BaseModal;
